const MS_IN_A_SECOND = 1000;

export const dateFromSeconds = (seconds: number): Date => new Date(seconds * MS_IN_A_SECOND);
